// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .filter-menu-container .search-container {
  position: sticky;
  top: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
}
::ng-deep .filter-menu-container .search-container .search-input {
  width: 100%;
  padding: 0.5rem;
  background-color: white;
}
::ng-deep .filter-menu-container .search-container .clear-filter-button {
  right: 0.5rem;
}
::ng-deep .dark-mode .filter-menu-container .search-container .search-input {
  background-color: #424242 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/filter-menu/filter-menu.component.scss"],"names":[],"mappings":"AAIE;EACC,gBAAA;EACA,MAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,WAAA;AAHH;AAKG;EACC,WAAA;EACA,eAAA;EACA,uBAAA;AAHJ;AAMG;EACC,aAAA;AAJJ;AAYI;EACC,oCAAA;AAVL","sourcesContent":["@import '../../../../styles/colors';\n\n::ng-deep {\n\t.filter-menu-container {\n\t\t.search-container {\n\t\t\tposition: sticky;\n\t\t\ttop: 0;\n\t\t\tz-index: 100;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\twidth: 100%;\n\n\t\t\t.search-input {\n\t\t\t\twidth: 100%;\n\t\t\t\tpadding: 0.5rem;\n\t\t\t\tbackground-color: white;\n\t\t\t}\n\n\t\t\t.clear-filter-button {\n\t\t\t\tright: 0.5rem;\n\t\t\t}\n\t\t}\n\t}\n\n\t.dark-mode {\n\t\t.filter-menu-container {\n\t\t\t.search-container {\n\t\t\t\t.search-input {\n\t\t\t\t\tbackground-color: $component-background-dark !important;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
